import { css } from 'styled-system/css';

export const streamingBaseStyle = {
	loading: css({
		base: {
			color: 'whiteOpacity.54',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minH: '210px',
		},
		_galaxy: {
			color: 'var(--lv1-80)',
		},
	})
}